import {http} from './config';

export default {
    listarCredenciais: (params = {}) => http.get('api/v1/integration-credentials', {params}),
    listarEmpreendimentos: (params = {}) => http.get('api/v1/app-facilita/empreendimentos', {params}),
};
